"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartCountResponseSchema = void 0;
var zod_1 = require("zod");
exports.CartCountResponseSchema = zod_1.z.object({
    code: zod_1.z.union([zod_1.z.literal('SUCCESS'), zod_1.z.literal('FAILED')]),
    data: zod_1.z.object({ count: zod_1.z.number() }).nullish(),
});
